import { create } from 'zustand';

interface CurrentPostState {
  postId: string | null;
  setPostId: (id: string | null) => void;
}

export const useCurrentPostStore = create<CurrentPostState>((set) => ({
  postId: null,
  setPostId: (id) => set({ postId: id }),
}));

